import { render, staticRenderFns } from "./Licencas.vue?vue&type=template&id=102dc484&scoped=true&"
import script from "./Licencas.vue?vue&type=script&lang=js&"
export * from "./Licencas.vue?vue&type=script&lang=js&"
import style0 from "./Licencas.vue?vue&type=style&index=0&id=102dc484&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "102dc484",
  null
  
)

export default component.exports